<app-navbar [isMultilanguage]="false"></app-navbar>
<ng-container *ngIf="loaded; else spinner">
  <header [ngStyle]="{ 'background-image': 'url(' + products[0].imageUrl + ')' }">
    <div class="title">
      {{ products[0]?.name }}
    </div>

    <div class="region">{{ products[0]?.brief }}</div>
  </header>

  <section class="container" *ngIf="options.length > 0">
    <app-product-item *ngFor="let option of options; trackBy: trackByFn" [languages]="languages" [option]="option">
    </app-product-item>
  </section>

  <footer>
    <div class="container">
      <div class="footer__wrapper">
        <div class="cards left">
          <img [src]="baseUrl + 'assets/images/master-card-logo.svg'" alt="Mastercard" />
          <img [src]="baseUrl + 'assets/images/visa-logo.svg'" alt="Visa" />
          <img [src]="baseUrl + 'assets/images/american-express.png'" alt="American Express" />
        </div>

        <div class="right">
          <ul class="menu">
            <li>
              <a href="https://www.winerist.com/contact-us" target="_blank">
                <ng-container i18n="Caption of the link to the contact us page|On the Main screen"
                  >Contact Us</ng-container
                >
              </a>
            </li>
            <li>
              <a href="https://www.winerist.com/terms-conditions" target="_blank">
                <ng-container i18n="Caption of the link to the terms and conditions page|On the Main screen"
                  >Terms &amp; Conditions</ng-container
                ></a
              >
            </li>
            <li>© {{ currentDate | date: 'yyyy' }} {{ pageConfig ? pageConfig.companyName : 'Winerist GO' }}</li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</ng-container>

<ng-template #spinner>
  <div class="spinner-container">
    <mat-spinner mode="indeterminate"></mat-spinner>
  </div>
</ng-template>

<ng-template #partnerLogo>
  <a
    [href]="pageConfig.bookingWidgetUrl ? 'http://' + pageConfig.bookingWidgetUrl + '/' : '#'"
    class="partner-logo"
    [ngStyle]="{ 'background-image': 'url(' + pageConfig?.logoUrl + ')' }"
  >
  </a>
</ng-template>
